import React, { useMemo, useState, useEffect } from 'react';
import { useGetFundDetailsQuery } from 'services/newApi/fundsApi';
import { GRID_ROW_HEIGHT } from 'shared/components/DataGrid/BacktestingExceptionsGrid/constants';
import { SingleColumnGrid } from 'shared/components/DataGrid/SingleColumnGrid';
import { FullViewLoading } from 'shared/components/FullViewLoading';
import { useDisplayFormattedValue } from 'shared/hooks';
import { mapBacktestingPortfolioValueGrid } from 'shared/mappers';
import { useAppSelector } from 'state/store';
import './BacktestingPortfolioValueGrid.scss';

export const BacktestingPortfolioValueGrid: React.FC = () => {
  const [skip, setSkip] = useState<boolean>(true);
  const [showLoading, setShowLoading] = useState<boolean>(true);
  const { measureType } = useAppSelector((state) => state.uiState);
  const { selectedFund } = useAppSelector((state) => state.fundsState);
  const { selectedValuationDate: valuationDate } = useAppSelector(
    (state) => state.valuationDatesState
  );
  const {
    data: fundMeasureList = [],
    isError,
    isFetching,
  } = useGetFundDetailsQuery(
    {
      valuationDate,
      measureType,
      fund: selectedFund,
    },
    { skip }
  );
  const customizeText = useDisplayFormattedValue();
  const customizeCaptions = ['Name', '99% Exceptions (250 days)'];

  const tableData = mapBacktestingPortfolioValueGrid({
    fundMeasureList,
  });
  const calculatedGridHeight = useMemo(
    () => (tableData.length + 1) * GRID_ROW_HEIGHT,
    [tableData]
  );

  useEffect(() => {
    if (valuationDate && selectedFund && skip) {
      setSkip(false);
    }
  }, [isFetching, selectedFund, skip, valuationDate]);

  useEffect(() => {
    if ((fundMeasureList?.length && !isFetching) || isError)
      setShowLoading(false);
  }, [fundMeasureList?.length, isError, isFetching]);

  return (
    <div className="backtesting-portfolio-grid">
      <FullViewLoading forceLoadingScreen={showLoading}>
        <SingleColumnGrid
          title="Funds"
          height={calculatedGridHeight}
          dataFromApi={tableData}
          customizeText={customizeText}
          customizeCaptions={customizeCaptions}
          showColumnHeaders
        />
      </FullViewLoading>
    </div>
  );
};
